@if (formGroup$ | async; as formGroup) {
  <form [formGroup]="formGroup">
    <div class="container">
      <div class="row">
        <div class="col">
          <pas-input
            [maxLength]="6"
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('supplierNumber'))"
            (ngModelChange)="onSupplierNumberChanged(formGroup)"
            formControlName="supplierNumber"
            subLabel="{{ 'supplierCondition.supplierNumber' | translate }}"></pas-input>
        </div>
        <div class="col">
          <div class="row m-0">
            <div class="col-11 p-0">
              <pas-input
                [validationMessages]="validationMessages"
                [formControl]="$any(formGroup.get('supplierName'))"
                formControlName="supplierName"
                subLabel="{{ 'supplierCondition.supplierName' | translate }}"></pas-input>
            </div>
            <div class="col-1 p-0">
              @if (spinnerActive) {
                <pas-spinner [size]="'small'"></pas-spinner>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <pas-input-number
            [maxLength]="4"
            [minimumValue]="0"
            [maximumValue]="1000"
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('thirdPartyCostsFactor'))"
            formControlName="thirdPartyCostsFactor"
            subLabel="{{ 'supplierCondition.thirdPartyCostsFactor' | translate }}"></pas-input-number>
        </div>
        <div class="col">
          <pas-input-number
            [maxLength]="4"
            [minimumValue]="0"
            [maximumValue]="1000"
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('thirdPartyMaterialCostsFactor'))"
            formControlName="thirdPartyMaterialCostsFactor"
            subLabel="{{ 'supplierCondition.thirdPartyMaterialCostsFactor' | translate }}"></pas-input-number>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <pas-input-number
            [maxLength]="4"
            [minimumValue]="0"
            [maximumValue]="1000"
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('handlingChargeCostsFactor'))"
            formControlName="handlingChargeCostsFactor"
            subLabel="{{ 'supplierCondition.handlingChargeCostsFactor' | translate }}"></pas-input-number>
        </div>
        <div class="col">
          <pas-input-number
            [maxLength]="4"
            [minimumValue]="0"
            [maximumValue]="1000"
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('handlingSupplierCostsFactor'))"
            formControlName="handlingSupplierCostsFactor"
            subLabel="{{ 'supplierCondition.handlingSupplierCostsFactor' | translate }}"></pas-input-number>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <pas-input-number
            [maxLength]="4"
            [minimumValue]="0"
            [maximumValue]="1000"
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('laborCostsFactor'))"
            formControlName="laborCostsFactor"
            subLabel="{{ 'supplierCondition.laborCostsFactor' | translate }}"></pas-input-number>
        </div>
        <div class="col">
          <pas-input-number
            [maxLength]="4"
            [minimumValue]="0"
            [maximumValue]="1000"
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('landingCostsFactor'))"
            formControlName="landingCostsFactor"
            subLabel="{{ 'supplierCondition.landingCostsFactor' | translate }}"></pas-input-number>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <pas-input-number
            [maxLength]="4"
            [minimumValue]="0"
            [maximumValue]="1000"
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('materialCostsFactor'))"
            formControlName="materialCostsFactor"
            subLabel="{{ 'supplierCondition.materialCostsFactor' | translate }}"></pas-input-number>
        </div>
        <div class="col">
          <pas-input-number
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('otherCosts'))"
            [decimalCount]="2"
            [decimalSeparator]="decimalSeparator"
            formControlName="otherCosts"
            subLabel="{{ 'supplierCondition.otherCosts' | translate }}"></pas-input-number>
        </div>
      </div>
      <!-- Only display date related fields on edit form -->
      @if ($any(formGroup.get('id')).value !== null) {
        <div class="row">
          <div class="col">
            <pas-datetime-picker
              [formControl]="$any(formGroup.get('createDate'))"
              formControlName="createDate"
              pickerType="date"
              subLabel="{{ 'supplierCondition.createDate' | translate }}"></pas-datetime-picker>
          </div>
          <div class="col">
            <pas-datetime-picker
              [formControl]="$any(formGroup.get('lastEditDate'))"
              formControlName="lastEditDate"
              pickerType="date"
              subLabel="{{ 'supplierCondition.lastEditDate' | translate }}"></pas-datetime-picker>
          </div>
        </div>
      }
    </div>
  </form>
}
